import { render } from "./Kakutei.vue?vue&type=template&id=6150d278&scoped=true"
import script from "./Kakutei.vue?vue&type=script&lang=js"
export * from "./Kakutei.vue?vue&type=script&lang=js"

import "./Kakutei.vue?vue&type=style&index=0&id=6150d278&scoped=true&lang=css"

import exportComponent from "/Users/masayukitenma/Documents/Develop/Container/claudedocs/l13-check/fe-build/mobile_main/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6150d278"]])

export default __exports__